var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditsolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22245 2.11731H3.00911C2.27245 2.11731 1.67578 2.74998 1.67578 3.52931V10.588C1.67578 11.368 2.27245 12 3.00911 12H10.3424C11.0791 12 11.6758 11.368 11.6758 10.588V5.42131L9.06645 8.18398C8.83858 8.42764 8.54183 8.59602 8.21578 8.66664L6.42845 9.04531C5.26178 9.29198 4.23378 8.20331 4.46711 6.96864L4.82445 5.07598C4.88911 4.73464 5.04778 4.42064 5.28045 4.17464L7.22245 2.11731Z",
    fill: "#5D848A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9049 0.878638C12.8375 0.707992 12.7387 0.551507 12.6136 0.417305C12.4906 0.286058 12.3423 0.181062 12.1776 0.108638C12.0154 0.037396 11.8401 0.000610352 11.6629 0.000610352C11.4858 0.000610352 11.3105 0.037396 11.1483 0.108638C10.9836 0.181062 10.8353 0.286058 10.7123 0.417305L10.3483 0.802638L12.2496 2.81597L12.6136 2.42997C12.74 2.29679 12.839 2.14003 12.9049 1.96864C13.0423 1.61828 13.0423 1.22899 12.9049 0.878638ZM11.3076 3.81397L9.40561 1.79997L6.22095 5.17331C6.17396 5.22337 6.14227 5.28582 6.12961 5.3533L5.77228 7.24664C5.72561 7.4933 5.93161 7.71064 6.16428 7.6613L7.95228 7.28331C8.01734 7.2688 8.07655 7.23513 8.12228 7.18664L11.3076 3.81397Z",
    fill: "#5D848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditsolid);
export default __webpack_public_path__ + "static/media/editsolid.81fc2e8775047eba9bdfa612e685ad19.svg";
export { ForwardRef as ReactComponent };